import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";
import AccountSettingsState from "@store/Store/Pages/AccountSettings/AccountSettingsState";
import { Draft } from "immer";

const initialState: AccountSettingsState = {
    isLoading: false,
    firstNameErrorMessage: "",
    lastNameErrorMessage: "",
    preferredDefaultLanguage: "",
};

const reducer = {
    "Store/Pages/AccountSettings/UpdateAccountSettings": (
        draft: Draft<AccountSettingsState>,
        action: {
            editingAccount: Partial<AccountModel>;
            baseEditingAccount?: AccountModel;
            firstNameErrorMessage?: string;
            lastNameErrorMessage?: string;
            preferredDefaultLanguage?: string;
        },
    ) => {
        if (!draft.editingAccount) {
            return;
        }
        
        if (action.baseEditingAccount) {
            const { firstName, lastName } = draft.editingAccount;
            draft.editingAccount = {
                ...action.baseEditingAccount,
                firstName,
                lastName,
            };
        }

        if (typeof action.editingAccount.firstName !== "undefined") {
            draft.editingAccount.firstName = action.editingAccount.firstName;
            draft.firstNameErrorMessage = action.firstNameErrorMessage;
        }

        if (typeof action.editingAccount.lastName !== "undefined") {
            draft.editingAccount.lastName = action.editingAccount.lastName;
            draft.lastNameErrorMessage = action.lastNameErrorMessage;
        }

        if (typeof action.preferredDefaultLanguage !== "undefined") {
            draft.preferredDefaultLanguage = action.preferredDefaultLanguage;
        }
    },
    "Store/Pages/AccountSettings/SetInitialValues": (
        draft: Draft<AccountSettingsState>,
        action: {
            account: AccountModel;
            baseEditingAccount: AccountModel;
        },
    ) => {
        const defaultState: AccountSettingsState = {
            ...initialState,
            editingAccount: {
                ...action.baseEditingAccount,
                firstName: action.account.firstName,
                lastName: action.account.lastName,
            }
        };

        Object.assign(draft, defaultState);
    },
    "Store/Pages/AccountSettings/SetIsLoading": (
        draft: Draft<AccountSettingsState>,
        action: { isLoading: boolean; },
    ) => {
        draft.isLoading = action.isLoading;
    },
};

const accountSettingsReducer = createTypedReducerWithImmer(initialState, reducer);
export default accountSettingsReducer;
